var markets = [
    {
        name: 'United States',
        transactable: true,
        countryCode: 'US',
        currency: 'USD'
    },
    {
        name: 'Afghanistan',
        transactable: true,
        countryCode: 'AF',
        currency: 'USD'
    },
    {
        name: 'Åland Islands',
        currency: 'USD',
        countryCode: 'AX'
    },
    {
        name: 'Albania',
        transactable: true,
        countryCode: 'AL',
        currency: 'USD'
    },
    {
        name: 'Algeria',
        transactable: true,
        countryCode: 'DZ',
        currency: 'USD'
    },
    {
        name: 'American Samoa',
        countryCode: 'AS',
        currency: 'USD'
    },
    {
        name: 'Andorra',
        transactable: true,
        countryCode: 'AD',
        currency: 'EUR'
    },
    {
        name: 'Angola',
        transactable: true,
        countryCode: 'AO',
        currency: 'USD'
    },
    {
        name: 'Anguilla',
        countryCode: 'AI',
        currency: 'USD'
    },
    {
        name: 'Antarctica',
        countryCode: 'AQ',
        currency: 'USD'
    },
    {
        name: 'Antigua and Barbuda',
        countryCode: 'AG',
        currency: 'USD'
    },
    {
        name: 'Argentina',
        transactable: true,
        countryCode: 'AR',
        currency: 'USD'
    },
    {
        name: 'Armenia',
        transactable: true,
        countryCode: 'AM',
        currency: 'USD'
    },
    {
        name: 'Aruba',
        countryCode: 'AW',
        currency: 'USD'
    },
    {
        name: 'Australia',
        transactable: true,
        countryCode: 'AU',
        currency: 'AUD'
    },
    {
        name: 'Austria',
        transactable: true,
        countryCode: 'AT',
        currency: 'EUR'
    },
    {
        name: 'Azerbaijan',
        transactable: true,
        countryCode: 'AZ',
        currency: 'USD'
    },
    {
        name: 'Bahamas',
        countryCode: 'BS',
        currency: 'USD'
    },
    {
        name: 'Bahrain',
        transactable: true,
        countryCode: 'BH',
        currency: 'USD'
    },
    {
        name: 'Bangladesh',
        transactable: true,
        countryCode: 'BD',
        currency: 'USD'
    },
    {
        name: 'Barbados',
        transactable: true,
        countryCode: 'BB',
        currency: 'USD'
    },
    {
        name: 'Belarus',
        transactable: true,
        countryCode: 'BY',
        currency: 'USD'
    },
    {
        name: 'Belgium',
        transactable: true,
        countryCode: 'BE',
        currency: 'EUR'
    },
    {
        name: 'Belize',
        transactable: true,
        countryCode: 'BZ',
        currency: 'USD'
    },
    {
        name: 'Benin',
        countryCode: 'BJ',
        currency: 'USD'
    },
    {
        name: 'Bermuda',
        transactable: true,
        countryCode: 'BM',
        currency: 'USD'
    },
    {
        name: 'Bhutan',
        countryCode: 'BT',
        currency: 'USD'
    },
    {
        name: 'Bolivia',
        transactable: true,
        countryCode: 'BO',
        currency: 'USD'
    },
    {
        name: 'Bonaire, Saint Eustatius and Saba',
        countryCode: 'BQ',
        currency: 'USD'
    },
    {
        name: 'Bosnia and Herzegovina',
        transactable: true,
        countryCode: 'BA',
        currency: 'USD'
    },
    {
        name: 'Botswana',
        transactable: true,
        countryCode: 'BW',
        currency: 'USD'
    },
    {
        name: 'Bouvet Island',
        countryCode: 'BV',
        currency: 'USD'
    },
    {
        name: 'Brazil',
        transactable: true,
        countryCode: 'BR',
        currency: 'BRL'
    },
    {
        name: 'British Indian Ocean Territory',
        countryCode: 'IO',
        currency: 'USD'
    },
    {
        name: 'British Virgin Islands',
        countryCode: 'VG',
        currency: 'USD'
    },
    {
        name: 'Brunei',
        transactable: true,
        countryCode: 'BN',
        currency: 'USD'
    },
    {
        name: 'Bulgaria',
        transactable: true,
        countryCode: 'BG',
        currency: 'EUR'
    },
    {
        name: 'Burkina Faso',
        countryCode: 'BF',
        currency: 'USD'
    },
    {
        name: 'Burundi',
        countryCode: 'BI',
        currency: 'USD'
    },
    {
        name: 'Cabo Verde',
        transactable: true,
        countryCode: 'CV',
        currency: 'USD'
    },
    {
        name: 'Cambodia',
        countryCode: 'KH',
        currency: 'KHR'
    },
    {
        name: 'Cameroon',
        transactable: true,
        countryCode: 'CM',
        currency: 'USD'
    },
    {
        name: 'Canada',
        transactable: true,
        countryCode: 'CA',
        currency: 'CAD'
    },
    {
        name: 'Cayman Islands',
        transactable: true,
        countryCode: 'KY',
        currency: 'USD'
    },
    {
        name: 'Central African Republic',
        countryCode: 'CF',
        currency: 'USD'
    },
    {
        name: 'Chad',
        countryCode: 'TD',
        currency: 'USD'
    },
    {
        name: 'Chile',
        transactable: true,
        countryCode: 'CL',
        currency: 'USD'
    },
    {
        name: 'China',
        countryCode: 'CN',
        currency: 'CNY'
    },
    {
        name: 'Christmas Island',
        countryCode: 'CX',
        currency: 'USD'
    },
    {
        name: 'Cocos (Keeling) Islands',
        countryCode: 'CC',
        currency: 'USD'
    },
    {
        name: 'Colombia',
        transactable: true,
        countryCode: 'CO',
        currency: 'USD'
    },
    {
        name: 'Comoros',
        countryCode: 'KM',
        currency: 'USD'
    },
    {
        name: 'Congo',
        countryCode: 'CG',
        currency: 'USD'
    },
    {
        name: 'Congo (DRC)',
        countryCode: 'CD',
        currency: 'USD'
    },
    {
        name: 'Cook Islands',
        countryCode: 'CK',
        currency: 'USD'
    },
    {
        name: 'Costa Rica',
        transactable: true,
        countryCode: 'CR',
        currency: 'USD'
    },
    {
        name: "Côte d'Ivoire",
        transactable: true,
        countryCode: 'CI',
        currency: 'USD'
    },
    {
        name: 'Croatia',
        transactable: true,
        countryCode: 'HR',
        currency: 'EUR'
    },
    {
        name: 'Curaçao',
        transactable: true,
        countryCode: 'CW',
        currency: 'USD'
    },
    {
        name: 'Cyprus',
        transactable: true,
        countryCode: 'CY',
        currency: 'EUR'
    },
    {
        name: 'Czechia',
        transactable: true,
        countryCode: 'CZ',
        currency: 'EUR'
    },
    {
        name: 'Denmark',
        transactable: true,
        countryCode: 'DK',
        currency: 'DKK'
    },
    {
        name: 'Djibouti',
        countryCode: 'DJ',
        currency: 'USD'
    },
    {
        name: 'Dominica',
        countryCode: 'DM',
        currency: 'USD'
    },
    {
        name: 'Dominican Republic',
        transactable: true,
        countryCode: 'DO',
        currency: 'USD'
    },
    {
        name: 'Ecuador',
        transactable: true,
        countryCode: 'EC',
        currency: 'USD'
    },
    {
        name: 'Egypt',
        transactable: true,
        countryCode: 'EG',
        currency: 'USD'
    },
    {
        name: 'El Salvador',
        transactable: true,
        countryCode: 'SV',
        currency: 'USD'
    },
    {
        name: 'Equatorial Guinea',
        countryCode: 'GQ',
        currency: 'USD'
    },
    {
        name: 'Eritrea',
        countryCode: 'ER',
        currency: 'USD'
    },
    {
        name: 'Estonia',
        transactable: true,
        countryCode: 'EE',
        currency: 'EUR'
    },
    {
        name: 'Ethiopia',
        transactable: true,
        countryCode: 'ET',
        currency: 'USD'
    },
    {
        name: 'Falkland Islands',
        countryCode: 'FK',
        currency: 'USD'
    },
    {
        name: 'Faroe Islands',
        transactable: true,
        countryCode: 'FO',
        currency: 'DKK'
    },
    {
        name: 'Fiji',
        transactable: true,
        countryCode: 'FJ',
        currency: 'AUD'
    },
    {
        name: 'Finland',
        transactable: true,
        countryCode: 'FI',
        currency: 'EUR'
    },
    {
        name: 'France',
        transactable: true,
        countryCode: 'FR',
        currency: 'EUR'
    },
    {
        name: 'French Guiana',
        countryCode: 'GF',
        currency: 'USD'
    },
    {
        name: 'French Polynesia',
        countryCode: 'PF',
        currency: 'USD'
    },
    {
        name: 'French Southern Territories',
        countryCode: 'TF',
        currency: 'USD'
    },
    {
        name: 'Gabon',
        countryCode: 'GA',
        currency: 'USD'
    },
    {
        name: 'Gambia',
        countryCode: 'GM',
        currency: 'USD'
    },
    {
        name: 'Georgia',
        transactable: true,
        countryCode: 'GE',
        currency: 'USD'
    },
    {
        name: 'Germany',
        transactable: true,
        countryCode: 'DE',
        currency: 'EUR'
    },
    {
        name: 'Ghana',
        transactable: true,
        countryCode: 'GH',
        currency: 'USD'
    },
    {
        name: 'Gibraltar',
        countryCode: 'GI',
        currency: 'EUR'
    },
    {
        name: 'Greece',
        transactable: true,
        countryCode: 'GR',
        currency: 'EUR'
    },
    {
        name: 'Greenland',
        countryCode: 'GL',
        currency: 'USD'
    },
    {
        name: 'Grenada',
        countryCode: 'GD',
        currency: 'USD'
    },
    {
        name: 'Guadeloupe',
        countryCode: 'GP',
        currency: 'USD'
    },
    {
        name: 'Guam',
        countryCode: 'GU',
        currency: 'USD'
    },
    {
        name: 'Guatemala',
        transactable: true,
        countryCode: 'GT',
        currency: 'USD'
    },
    {
        name: 'Guernsey',
        countryCode: 'GG',
        currency: 'EUR'
    },
    {
        name: 'Guinea',
        countryCode: 'GN',
        currency: 'USD'
    },
    {
        name: 'Guinea-Bissau',
        countryCode: 'GW',
        currency: 'USD'
    },
    {
        name: 'Guyana',
        countryCode: 'GY',
        currency: 'USD'
    },
    {
        name: 'Haiti',
        countryCode: 'HT',
        currency: 'USD'
    },
    {
        name: 'Heard Island and McDonald Islands',
        countryCode: 'HM',
        currency: 'USD'
    },
    {
        name: 'Honduras',
        transactable: true,
        countryCode: 'HN',
        currency: 'USD'
    },
    {
        name: 'Hong Kong SAR',
        transactable: true,
        countryCode: 'HK',
        currency: 'USD'
    },
    {
        name: 'Hungary',
        transactable: true,
        countryCode: 'HU',
        currency: 'EUR'
    },
    {
        name: 'Iceland',
        transactable: true,
        countryCode: 'IS',
        currency: 'EUR'
    },
    {
        name: 'India',
        transactable: true,
        countryCode: 'IN',
        currency: 'INR'
    },
    {
        name: 'Indonesia',
        transactable: true,
        countryCode: 'ID',
        currency: 'USD'
    },
    {
        name: 'Iraq',
        transactable: true,
        countryCode: 'IQ',
        currency: 'USD'
    },
    {
        name: 'Ireland',
        transactable: true,
        countryCode: 'IE',
        currency: 'EUR'
    },
    {
        name: 'Isle of Man',
        countryCode: 'IM',
        currency: 'USD'
    },
    {
        name: 'Israel',
        transactable: true,
        countryCode: 'IL',
        currency: 'USD'
    },
    {
        name: 'Italy',
        transactable: true,
        countryCode: 'IT',
        currency: 'EUR'
    },
    {
        name: 'Jamaica',
        transactable: true,
        countryCode: 'JM',
        currency: 'USD'
    },
    {
        name: 'Japan',
        transactable: true,
        countryCode: 'JP',
        currency: 'JPY'
    },
    {
        name: 'Jersey',
        countryCode: 'JE',
        currency: 'EUR'
    },
    {
        name: 'Jordan',
        transactable: true,
        countryCode: 'JO',
        currency: 'USD'
    },
    {
        name: 'Kazakhstan',
        transactable: true,
        countryCode: 'KZ',
        currency: 'USD'
    },
    {
        name: 'Kenya',
        transactable: true,
        countryCode: 'KE',
        currency: 'USD'
    },
    {
        name: 'Kiribati',
        countryCode: 'KI',
        currency: 'USD'
    },
    {
        name: 'Korea (South)',
        transactable: true,
        countryCode: 'KR',
        currency: 'KRW'
    },
    {
        name: 'Kosovo',
        countryCode: 'XK',
        currency: 'USD'
    },
    {
        name: 'Kuwait',
        transactable: true,
        countryCode: 'KW',
        currency: 'USD'
    },
    {
        name: 'Kyrgyzstan',
        transactable: true,
        countryCode: 'KG',
        currency: 'USD'
    },
    {
        name: 'Laos',
        countryCode: 'LA',
        currency: 'USD'
    },
    {
        name: 'Latvia',
        transactable: true,
        countryCode: 'LV',
        currency: 'EUR'
    },
    {
        name: 'Lebanon',
        transactable: true,
        countryCode: 'LB',
        currency: 'USD'
    },
    {
        name: 'Lesotho',
        countryCode: 'LS',
        currency: 'USD'
    },
    {
        name: 'Liberia',
        countryCode: 'LR',
        currency: 'USD'
    },
    {
        name: 'Libya',
        transactable: true,
        countryCode: 'LY',
        currency: 'USD'
    },
    {
        name: 'Liechtenstein',
        transactable: true,
        countryCode: 'LI',
        currency: 'EUR'
    },
    {
        name: 'Lithuania',
        transactable: true,
        countryCode: 'LT',
        currency: 'EUR'
    },
    {
        name: 'Luxembourg',
        transactable: true,
        countryCode: 'LU',
        currency: 'EUR'
    },
    {
        name: 'Macao SAR',
        transactable: true,
        countryCode: 'MO',
        currency: 'USD'
    },
    {
        name: 'Madagascar',
        countryCode: 'MG',
        currency: 'USD'
    },
    {
        name: 'Malawi',
        countryCode: 'MW',
        currency: 'USD'
    },
    {
        name: 'Malaysia',
        transactable: true,
        countryCode: 'MY',
        currency: 'USD'
    },
    {
        name: 'Maldives',
        countryCode: 'MV',
        currency: 'USD'
    },
    {
        name: 'Mali',
        countryCode: 'ML',
        currency: 'USD'
    },
    {
        name: 'Malta',
        transactable: true,
        countryCode: 'MT',
        currency: 'EUR'
    },
    {
        name: 'Marshall Islands',
        countryCode: 'MH',
        currency: 'USD'
    },
    {
        name: 'Martinique',
        countryCode: 'MQ',
        currency: 'EUR'
    },
    {
        name: 'Mauritania',
        countryCode: 'MR',
        currency: 'MRO'
    },
    {
        name: 'Mauritius',
        transactable: true,
        countryCode: 'MU',
        currency: 'USD'
    },
    {
        name: 'Mayotte',
        countryCode: 'YT',
        currency: 'EUR'
    },
    {
        name: 'Mexico',
        transactable: true,
        countryCode: 'MX',
        currency: 'USD'
    },
    {
        name: 'Micronesia',
        countryCode: 'FM',
        currency: 'USD'
    },
    {
        name: 'Moldova',
        transactable: true,
        countryCode: 'MD',
        currency: 'USD'
    },
    {
        name: 'Monaco',
        transactable: true,
        countryCode: 'MC',
        currency: 'EUR'
    },
    {
        name: 'Mongolia',
        transactable: true,
        countryCode: 'MN',
        currency: 'USD'
    },
    {
        name: 'Montenegro',
        transactable: true,
        countryCode: 'ME',
        currency: 'USD'
    },
    {
        name: 'Montserrat',
        countryCode: 'MS',
        currency: 'USD'
    },
    {
        name: 'Morocco',
        transactable: true,
        countryCode: 'MA',
        currency: 'USD'
    },
    {
        name: 'Mozambique',
        countryCode: 'MZ',
        currency: 'USD'
    },
    {
        name: 'Myanmar',
        countryCode: 'MM',
        currency: 'USD'
    },
    {
        name: 'Namibia',
        transactable: true,
        countryCode: 'NA',
        currency: 'USD'
    },
    {
        name: 'Nauru',
        countryCode: 'NR',
        currency: 'USD'
    },
    {
        name: 'Nepal',
        transactable: true,
        countryCode: 'NP',
        currency: 'USD'
    },
    {
        name: 'Netherlands',
        transactable: true,
        countryCode: 'NL',
        currency: 'EUR'
    },
    {
        name: 'New Caledonia',
        countryCode: 'NC',
        currency: 'USD'
    },
    {
        name: 'New Zealand',
        transactable: true,
        countryCode: 'NZ',
        currency: 'NZD'
    },
    {
        name: 'Nicaragua',
        transactable: true,
        countryCode: 'NI',
        currency: 'USD'
    },
    {
        name: 'Niger',
        countryCode: 'NE',
        currency: 'USD'
    },
    {
        name: 'Nigeria',
        transactable: true,
        countryCode: 'NG',
        currency: 'USD'
    },
    {
        name: 'Niue',
        countryCode: 'NU',
        currency: 'USD'
    },
    {
        name: 'Norfolk Island',
        countryCode: 'NF',
        currency: 'USD'
    },
    {
        name: 'North Macedonia',
        transactable: true,
        countryCode: 'MK',
        currency: 'USD'
    },
    {
        name: 'Northern Mariana Islands',
        countryCode: 'MP',
        currency: 'USD'
    },
    {
        name: 'Norway',
        transactable: true,
        countryCode: 'NO',
        currency: 'NOK'
    },
    {
        name: 'Oman',
        transactable: true,
        countryCode: 'OM',
        currency: 'USD'
    },
    {
        name: 'Pakistan',
        transactable: true,
        countryCode: 'PK',
        currency: 'USD'
    },
    {
        name: 'Palau',
        countryCode: 'PW',
        currency: 'USD'
    },
    {
        name: 'Palestinian Authority',
        transactable: true,
        countryCode: 'PS',
        currency: 'USD'
    },
    {
        name: 'Panama',
        transactable: true,
        countryCode: 'PA',
        currency: 'USD'
    },
    {
        name: 'Papua New Guinea',
        countryCode: 'PG',
        currency: 'USD'
    },
    {
        name: 'Paraguay',
        transactable: true,
        countryCode: 'PY',
        currency: 'USD'
    },
    {
        name: 'Peru',
        transactable: true,
        countryCode: 'PE',
        currency: 'USD'
    },
    {
        name: 'Philippines',
        transactable: true,
        countryCode: 'PH',
        currency: 'USD'
    },
    {
        name: 'Pitcairn Islands',
        countryCode: 'PN',
        currency: 'USD'
    },
    {
        name: 'Poland',
        transactable: true,
        countryCode: 'PL',
        currency: 'EUR'
    },
    {
        name: 'Portugal',
        transactable: true,
        countryCode: 'PT',
        currency: 'EUR'
    },
    {
        name: 'Puerto Rico',
        transactable: true,
        countryCode: 'PR',
        currency: 'USD'
    },
    {
        name: 'Qatar',
        transactable: true,
        countryCode: 'QA',
        currency: 'USD'
    },
    {
        name: 'Réunion',
        countryCode: 'RE',
        currency: 'EUR'
    },
    {
        name: 'Romania',
        transactable: true,
        countryCode: 'RO',
        currency: 'EUR'
    },
    {
        name: 'Russia',
        transactable: true,
        countryCode: 'RU',
        currency: 'RUB'
    },
    {
        name: 'Rwanda',
        transactable: true,
        countryCode: 'RW',
        currency: 'USD'
    },
    {
        name: 'Saint Barthélemy',
        countryCode: 'BL',
        currency: 'EUR'
    },
    {
        name: 'Saint Helena, Ascension, Tristan da Cunha',
        countryCode: 'SH',
        currency: 'EUR'
    },
    {
        name: 'Saint Kitts and Nevis',
        transactable: true,
        countryCode: 'KN',
        currency: 'USD'
    },
    {
        name: 'Saint Lucia',
        countryCode: 'LC',
        currency: 'USD'
    },
    {
        name: 'Saint Martin',
        countryCode: 'MF',
        currency: 'USD'
    },
    {
        name: 'Saint Pierre and Miquelon',
        countryCode: 'PM',
        currency: 'USD'
    },
    {
        name: 'Saint Vincent and the Grenadines',
        countryCode: 'VC',
        currency: 'USD'
    },
    {
        name: 'Samoa',
        countryCode: 'WS',
        currency: 'USD'
    },
    {
        name: 'San Marino',
        countryCode: 'SM',
        currency: 'EUR'
    },
    {
        name: 'São Tomé and Príncipe',
        countryCode: 'ST',
        currency: 'USD'
    },
    {
        name: 'Saudi Arabia',
        transactable: true,
        countryCode: 'SA',
        currency: 'USD'
    },
    {
        name: 'Senegal',
        transactable: true,
        countryCode: 'SN',
        currency: 'USD'
    },
    {
        name: 'Serbia',
        transactable: true,
        countryCode: 'RS',
        currency: 'USD'
    },
    {
        name: 'Seychelles',
        countryCode: 'SC',
        currency: 'USD'
    },
    {
        name: 'Sierra Leone',
        countryCode: 'SL',
        currency: 'USD'
    },
    {
        name: 'Singapore',
        transactable: true,
        countryCode: 'SG',
        currency: 'USD'
    },
    {
        name: 'Sint Maarten',
        countryCode: 'SX',
        currency: 'USD'
    },
    {
        name: 'Slovakia',
        transactable: true,
        countryCode: 'SK',
        currency: 'EUR'
    },
    {
        name: 'Slovenia',
        transactable: true,
        countryCode: 'SI',
        currency: 'EUR'
    },
    {
        name: 'Solomon Islands',
        countryCode: 'SB',
        currency: 'USD'
    },
    {
        name: 'Somalia',
        countryCode: 'SO',
        currency: 'USD'
    },
    {
        name: 'South Africa',
        transactable: true,
        countryCode: 'ZA',
        currency: 'USD'
    },
    {
        name: 'South Georgia and South Sandwich Islands',
        countryCode: 'GS',
        currency: 'USD'
    },
    {
        name: 'South Sudan',
        countryCode: 'SS',
        currency: 'USD'
    },
    {
        name: 'Spain',
        transactable: true,
        countryCode: 'ES',
        currency: 'EUR'
    },
    {
        name: 'Sri Lanka',
        transactable: true,
        countryCode: 'LK',
        currency: 'USD'
    },
    {
        name: 'Suriname',
        countryCode: 'SR',
        currency: 'USD'
    },
    {
        name: 'Svalbard and Jan Mayen',
        countryCode: 'SJ',
        currency: 'USD'
    },
    {
        name: 'Swaziland',
        countryCode: 'SZ',
        currency: 'USD'
    },
    {
        name: 'Sweden',
        transactable: true,
        countryCode: 'SE',
        currency: 'SEK'
    },
    {
        name: 'Switzerland',
        transactable: true,
        countryCode: 'CH',
        currency: 'CHF'
    },
    {
        name: 'Taiwan',
        transactable: true,
        countryCode: 'TW',
        currency: 'TWD'
    },
    {
        name: 'Tajikistan',
        transactable: true,
        countryCode: 'TJ',
        currency: 'USD'
    },
    {
        name: 'Tanzania',
        transactable: true,
        countryCode: 'TZ',
        currency: 'USD'
    },
    {
        name: 'Thailand',
        transactable: true,
        countryCode: 'TH',
        currency: 'USD'
    },
    {
        name: 'Timor-Leste',
        countryCode: 'TL',
        currency: 'USD'
    },
    {
        name: 'Togo',
        countryCode: 'TG',
        currency: 'USD'
    },
    {
        name: 'Tokelau',
        countryCode: 'TK',
        currency: 'USD'
    },
    {
        name: 'Tonga',
        countryCode: 'TO',
        currency: 'USD'
    },
    {
        name: 'Trinidad and Tobago',
        transactable: true,
        countryCode: 'TT',
        currency: 'USD'
    },
    {
        name: 'Tunisia',
        transactable: true,
        countryCode: 'TN',
        currency: 'USD'
    },
    {
        name: 'Turkey',
        transactable: true,
        countryCode: 'TR',
        currency: 'USD'
    },
    {
        name: 'Turkmenistan',
        transactable: true,
        countryCode: 'TM',
        currency: 'USD'
    },
    {
        name: 'Turks and Caicos Islands',
        countryCode: 'TC',
        currency: 'USD'
    },
    {
        name: 'Tuvalu',
        countryCode: 'TV',
        currency: 'USD'
    },
    {
        name: 'U.S. Outlying Islands',
        countryCode: 'UM',
        currency: 'USD'
    },
    {
        name: 'U.S. Virgin Islands',
        transactable: true,
        countryCode: 'VI',
        currency: 'USD'
    },
    {
        name: 'Uganda',
        transactable: true,
        countryCode: 'UG',
        currency: 'USD'
    },
    {
        name: 'Ukraine',
        transactable: true,
        countryCode: 'UA',
        currency: 'USD'
    },
    {
        name: 'United Arab Emirates',
        transactable: true,
        countryCode: 'AE',
        currency: 'USD'
    },
    {
        name: 'United Kingdom',
        transactable: true,
        countryCode: 'GB',
        currency: 'GBP'
    },
    {
        name: 'Uruguay',
        transactable: true,
        countryCode: 'UY',
        currency: 'USD'
    },
    {
        name: 'Uzbekistan',
        transactable: true,
        countryCode: 'UZ',
        currency: 'USD'
    },
    {
        name: 'Vanuatu',
        countryCode: 'VU',
        currency: 'USD'
    },
    {
        name: 'Vatican City (Holy See)',
        transactable: true,
        countryCode: 'VA',
        currency: 'EUR'
    },
    {
        name: 'Venezuela',
        transactable: true,
        countryCode: 'VE',
        currency: 'USD'
    },
    {
        name: 'Vietnam',
        transactable: true,
        countryCode: 'VN',
        currency: 'USD'
    },
    {
        name: 'Wallis and Futuna',
        countryCode: 'WF',
        currency: 'USD'
    },
    {
        name: 'Yemen',
        transactable: true,
        countryCode: 'YE',
        currency: 'USD'
    },
    {
        name: 'Zambia',
        transactable: true,
        countryCode: 'ZM',
        currency: 'USD'
    },
    {
        name: 'Zimbabwe',
        transactable: true,
        countryCode: 'ZW',
        currency: 'USD'
    }
];

export { markets };
